import { Component, Inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@app/core/cdk/dialog';
import { PopinSize } from '@app/shared/utils';
import { ActionsEnum } from '@app/shared/utils/enums/actions.enum';

@Component({
  selector: 'app-combine-products-popin',
  templateUrl: './combine-products-popin.component.html',
  styleUrls: ['./combine-products-popin.component.scss'],
})
export class CombineProductsPopinComponent {
  DialogSize = PopinSize;
  product_count: number;

  constructor(@Inject(DIALOG_DATA) public data: any, private _dialogRef: DialogRef<CombineProductsPopinComponent>) {
    if (data && data.wet_count_product) {
      this.product_count = data.wet_count_product;
    }
  }

  cancel(event) {
    event.stopPropagation();
    this._dialogRef.close({
      button: ActionsEnum.no,
    });
  }

  goForMixFeeding(event) {
    event.stopPropagation();
    this._dialogRef.close({
      button: ActionsEnum.yes,
    });
  }
}
